export default __webpack_public_path__ + "static/media/business_dashboard.fd93c29a.png";